import { render, staticRenderFns } from "./AdvertisingError.vue?vue&type=template&id=b16ce1e4&scoped=true&"
import script from "./AdvertisingError.vue?vue&type=script&lang=ts&"
export * from "./AdvertisingError.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertisingError.vue?vue&type=style&index=0&id=b16ce1e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16ce1e4",
  null
  
)

export default component.exports